(() => {
var $97b41775eca857bf$exports = {};
/*! jquery-qrcode v0.18.0 - https://larsjung.de/jquery-qrcode/ */ !function(t, r) {
    $97b41775eca857bf$exports = r();
}("undefined" != typeof self ? self : $97b41775eca857bf$exports, function() {
    var e, n;
    return n = {}, o.m = e = [
        function(t, r, f) {
            function p(t) {
                return t && "string" == typeof t.tagName && "IMG" === t.tagName.toUpperCase();
            }
            function h(t, r, e, n, o) {
                e = Math.max(1, e || 1), n = Math.min(40, n || 40);
                for(var i = e; i <= n; i += 1)try {
                    return function(t, r, e, n) {
                        var o = {}, i = f(1);
                        i.stringToBytes = i.stringToBytesFuncs["UTF-8"];
                        var a = i(e, r);
                        a.addData(t), a.make(), n = n || 0;
                        var u = a.getModuleCount(), s = u + 2 * n;
                        return o.text = t, o.level = r, o.version = e, o.module_count = s, o.is_dark = function(t, r) {
                            return r -= n, 0 <= (t -= n) && t < u && 0 <= r && r < u && a.isDark(t, r);
                        }, o.add_blank = function(a, u, f, l) {
                            var c = o.is_dark, g = 1 / s;
                            o.is_dark = function(t, r) {
                                var e = r * g, n = t * g, o = e + g, i = n + g;
                                return c(t, r) && (o < a || f < e || i < u || l < n);
                            };
                        }, o;
                    }(t, r, i, o);
                } catch (t) {}
            }
            function i(t, r, e) {
                p(e.background) ? r.drawImage(e.background, 0, 0, e.size, e.size) : e.background && (r.fillStyle = e.background, r.fillRect(e.left, e.top, e.size, e.size));
                var n, o, i, a, u, f, l, c, g, s, h, d, v = e.mode;
                1 === v || 2 === v ? function(t, r, e) {
                    var n = e.size, o = "bold " + e.mSize * n + "px " + e.fontname, i = w("<canvas/>")[0].getContext("2d");
                    i.font = o;
                    var a = i.measureText(e.label).width, u = e.mSize, f = a / n, l = (1 - f) * e.mPosX, c = (1 - u) * e.mPosY, g = l + f, s = c + u;
                    1 === e.mode ? t.add_blank(0, c - .01, n, s + .01) : t.add_blank(l - .01, c - .01, .01 + g, s + .01), r.fillStyle = e.fontcolor, r.font = o, r.fillText(e.label, l * n, c * n + .75 * e.mSize * n);
                }(t, r, e) : !p(e.image) || 3 !== v && 4 !== v || (n = t, o = r, a = (i = e).size, u = i.image.naturalWidth || 1, f = i.image.naturalHeight || 1, l = i.mSize, g = (1 - (c = l * u / f)) * i.mPosX, s = (1 - l) * i.mPosY, h = g + c, d = s + l, 3 === i.mode ? n.add_blank(0, s - .01, a, d + .01) : n.add_blank(g - .01, s - .01, .01 + h, d + .01), o.drawImage(i.image, g * a, s * a, c * a, l * a));
            }
            function s(t, r, e, n, o, i, a, u) {
                t.is_dark(a, u) && r.r(n, o, i, i);
            }
            function d(t, r, e, n, o, i, a, u) {
                var f, l, c, g, s, h, d, v, p, w, y, m, b, k, x, B, C, A, M, S = n + i, L = o + i, D = e.radius * i, T = a - 1, z = a + 1, P = u - 1, j = u + 1, I = t.is_dark, _ = I(a, u), q = I(T, P), O = I(T, u), F = I(T, j), R = I(a, j), H = I(z, j), N = I(z, u), U = I(z, P), V = I(a, P);
                _ ? (w = r, y = n, m = o, b = S, k = L, x = D, C = !O && !R, A = !N && !R, M = !N && !V, (B = !O && !V) ? w.m(y + x, m) : w.m(y, m), C ? w.l(b - x, m).a(b, m, b, k, x) : w.l(b, m), A ? w.l(b, k - x).a(b, k, y, k, x) : w.l(b, k), M ? w.l(y + x, k).a(y, k, y, m, x) : w.l(y, k), B ? w.l(y, m + x).a(y, m, b, m, x) : w.l(y, m)) : (f = r, l = n, c = o, g = S, s = L, h = D, d = O && R && F, v = N && R && H, p = N && V && U, O && V && q && f.m(l + h, c).l(l, c).l(l, c + h).a(l, c, l + h, c, h), d && f.m(g - h, c).l(g, c).l(g, c + h).a(g, c, g - h, c, h), v && f.m(g - h, s).l(g, s).l(g, s - h).a(g, s, g - h, s, h), p && f.m(l + h, s).l(l, s).l(l, s - h).a(l, s, l + h, s, h));
            }
            function n(t, r) {
                var e = h(r.text, r.ecLevel, r.minVersion, r.maxVersion, r.quiet);
                if (!e) return null;
                var n = w(t).data("qrcode", e), o = n[0].getContext("2d");
                return i(e, o, r), function(t, e, r) {
                    var n = t.module_count, o = r.size / n, i = s;
                    0 < r.radius && r.radius <= .5 && (i = d);
                    var a = {
                        m: function(t, r) {
                            return e.moveTo(t, r), a;
                        },
                        l: function(t, r) {
                            return e.lineTo(t, r), a;
                        },
                        a: function() {
                            return e.arcTo.apply(e, arguments), a;
                        },
                        r: function() {
                            return e.rect.apply(e, arguments), a;
                        }
                    };
                    e.beginPath();
                    for(var u, f = 0; f < n; f += 1)for(var l = 0; l < n; l += 1){
                        var c = r.left + l * o, g = r.top + f * o;
                        i(t, a, r, c, g, o, f, l);
                    }
                    p(r.fill) ? (e.strokeStyle = "rgba(0,0,0,0.5)", e.lineWidth = 2, e.stroke(), u = e.globalCompositeOperation, e.globalCompositeOperation = "destination-out", e.fill(), e.globalCompositeOperation = u, e.clip(), e.drawImage(r.fill, 0, 0, r.size, r.size), e.restore()) : (e.fillStyle = r.fill, e.fill());
                }(e, o, r), n;
            }
            function e(t) {
                var r = w("<canvas/>").attr("width", t.size).attr("height", t.size);
                return n(r, t);
            }
            function o(t) {
                var r;
                return "canvas" === t.render ? e(t) : "image" === t.render ? (r = t, w("<img/>").attr("src", e(r)[0].toDataURL("image/png"))) : function(t) {
                    var r = h(t.text, t.ecLevel, t.minVersion, t.maxVersion, t.quiet);
                    if (!r) return null;
                    var e = t.size, n = t.background, o = Math.floor, i = r.module_count, a = o(e / i), u = o(.5 * (e - a * i)), f = {
                        position: "relative",
                        left: 0,
                        top: 0,
                        padding: 0,
                        margin: 0,
                        width: e,
                        height: e
                    }, l = {
                        position: "absolute",
                        padding: 0,
                        margin: 0,
                        width: a,
                        height: a,
                        "background-color": t.fill
                    }, c = w("<div/>").data("qrcode", r).css(f);
                    n && c.css("background-color", n);
                    for(var g = 0; g < i; g += 1)for(var s = 0; s < i; s += 1)r.is_dark(g, s) && w("<div/>").css(l).css({
                        left: u + s * a,
                        top: u + g * a
                    }).appendTo(c);
                    return c;
                }(t);
            }
            var w = window.jQuery, a = {
                render: "canvas",
                minVersion: 1,
                maxVersion: 40,
                ecLevel: "L",
                left: 0,
                top: 0,
                size: 200,
                fill: "#000",
                background: "#fff",
                text: "no text",
                radius: 0,
                quiet: 0,
                mode: 0,
                mSize: .1,
                mPosX: .5,
                mPosY: .5,
                label: "no label",
                fontname: "sans",
                fontcolor: "#000",
                image: null
            };
            w.fn.qrcode = t.exports = function(t) {
                var e = w.extend({}, a, t);
                return this.each(function(t, r) {
                    "canvas" === r.nodeName.toLowerCase() ? n(r, e) : w(r).append(o(e));
                });
            };
        },
        function(t, r, e) {
            var n, o, i, a = function() {
                function i(t, r) {
                    function a(t, r) {
                        c = function(t) {
                            for(var r = new Array(t), e = 0; e < t; e += 1){
                                r[e] = new Array(t);
                                for(var n = 0; n < t; n += 1)r[e][n] = null;
                            }
                            return r;
                        }(g = 4 * u + 17), e(0, 0), e(g - 7, 0), e(0, g - 7), i(), o(), d(t, r), 7 <= u && s(t), null == n && (n = p(u, f, l)), v(n, r);
                    }
                    var u = t, f = y[r], c = null, g = 0, n = null, l = [], h = {}, e = function(t, r) {
                        for(var e = -1; e <= 7; e += 1)if (!(t + e <= -1 || g <= t + e)) for(var n = -1; n <= 7; n += 1)r + n <= -1 || g <= r + n || (c[t + e][r + n] = 0 <= e && e <= 6 && (0 == n || 6 == n) || 0 <= n && n <= 6 && (0 == e || 6 == e) || 2 <= e && e <= 4 && 2 <= n && n <= 4);
                    }, o = function() {
                        for(var t = 8; t < g - 8; t += 1)null == c[t][6] && (c[t][6] = t % 2 == 0);
                        for(var r = 8; r < g - 8; r += 1)null == c[6][r] && (c[6][r] = r % 2 == 0);
                    }, i = function() {
                        for(var t = m.getPatternPosition(u), r = 0; r < t.length; r += 1)for(var e = 0; e < t.length; e += 1){
                            var n = t[r], o = t[e];
                            if (null == c[n][o]) for(var i = -2; i <= 2; i += 1)for(var a = -2; a <= 2; a += 1)c[n + i][o + a] = -2 == i || 2 == i || -2 == a || 2 == a || 0 == i && 0 == a;
                        }
                    }, s = function(t) {
                        for(var r = m.getBCHTypeNumber(u), e = 0; e < 18; e += 1){
                            var n = !t && 1 == (r >> e & 1);
                            c[Math.floor(e / 3)][e % 3 + g - 8 - 3] = n;
                        }
                        for(e = 0; e < 18; e += 1){
                            n = !t && 1 == (r >> e & 1);
                            c[e % 3 + g - 8 - 3][Math.floor(e / 3)] = n;
                        }
                    }, d = function(t, r) {
                        for(var e = f << 3 | r, n = m.getBCHTypeInfo(e), o = 0; o < 15; o += 1){
                            var i = !t && 1 == (n >> o & 1);
                            o < 6 ? c[o][8] = i : o < 8 ? c[o + 1][8] = i : c[g - 15 + o][8] = i;
                        }
                        for(o = 0; o < 15; o += 1){
                            i = !t && 1 == (n >> o & 1);
                            o < 8 ? c[8][g - o - 1] = i : o < 9 ? c[8][15 - o - 1 + 1] = i : c[8][15 - o - 1] = i;
                        }
                        c[g - 8][8] = !t;
                    }, v = function(t, r) {
                        for(var e = -1, n = g - 1, o = 7, i = 0, a = m.getMaskFunction(r), u = g - 1; 0 < u; u -= 2)for(6 == u && --u;;){
                            for(var f, l = 0; l < 2; l += 1)null == c[n][u - l] && (f = !1, i < t.length && (f = 1 == (t[i] >>> o & 1)), a(n, u - l) && (f = !f), c[n][u - l] = f, -1 == --o && (i += 1, o = 7));
                            if ((n += e) < 0 || g <= n) {
                                n -= e, e = -e;
                                break;
                            }
                        }
                    }, p = function(t, r, e) {
                        for(var n = A.getRSBlocks(t, r), o = M(), i = 0; i < e.length; i += 1){
                            var a = e[i];
                            o.put(a.getMode(), 4), o.put(a.getLength(), m.getLengthInBits(a.getMode(), t)), a.write(o);
                        }
                        for(var u = 0, i = 0; i < n.length; i += 1)u += n[i].dataCount;
                        if (o.getLengthInBits() > 8 * u) throw "code length overflow. (" + o.getLengthInBits() + ">" + 8 * u + ")";
                        for(o.getLengthInBits() + 4 <= 8 * u && o.put(0, 4); o.getLengthInBits() % 8 != 0;)o.putBit(!1);
                        for(; !(o.getLengthInBits() >= 8 * u || (o.put(236, 8), o.getLengthInBits() >= 8 * u));)o.put(17, 8);
                        return function(t, r) {
                            for(var e = 0, n = 0, o = 0, i = new Array(r.length), a = new Array(r.length), u = 0; u < r.length; u += 1){
                                var f = r[u].dataCount, l = r[u].totalCount - f, n = Math.max(n, f), o = Math.max(o, l);
                                i[u] = new Array(f);
                                for(var c = 0; c < i[u].length; c += 1)i[u][c] = 255 & t.getBuffer()[c + e];
                                e += f;
                                var g = m.getErrorCorrectPolynomial(l), s = b(i[u], g.getLength() - 1).mod(g);
                                a[u] = new Array(g.getLength() - 1);
                                for(c = 0; c < a[u].length; c += 1){
                                    var h = c + s.getLength() - a[u].length;
                                    a[u][c] = 0 <= h ? s.getAt(h) : 0;
                                }
                            }
                            for(var d = 0, c = 0; c < r.length; c += 1)d += r[c].totalCount;
                            for(var v = new Array(d), p = 0, c = 0; c < n; c += 1)for(u = 0; u < r.length; u += 1)c < i[u].length && (v[p] = i[u][c], p += 1);
                            for(c = 0; c < o; c += 1)for(u = 0; u < r.length; u += 1)c < a[u].length && (v[p] = a[u][c], p += 1);
                            return v;
                        }(o, n);
                    };
                    h.addData = function(t, r) {
                        var e = null;
                        switch(r = r || "Byte"){
                            case "Numeric":
                                e = S(t);
                                break;
                            case "Alphanumeric":
                                e = L(t);
                                break;
                            case "Byte":
                                e = D(t);
                                break;
                            case "Kanji":
                                e = T(t);
                                break;
                            default:
                                throw "mode:" + r;
                        }
                        l.push(e), n = null;
                    }, h.isDark = function(t, r) {
                        if (t < 0 || g <= t || r < 0 || g <= r) throw t + "," + r;
                        return c[t][r];
                    }, h.getModuleCount = function() {
                        return g;
                    }, h.make = function() {
                        if (u < 1) {
                            for(var t = 1; t < 40; t++){
                                for(var r = A.getRSBlocks(t, f), e = M(), n = 0; n < l.length; n++){
                                    var o = l[n];
                                    e.put(o.getMode(), 4), e.put(o.getLength(), m.getLengthInBits(o.getMode(), t)), o.write(e);
                                }
                                for(var i = 0, n = 0; n < r.length; n++)i += r[n].dataCount;
                                if (e.getLengthInBits() <= 8 * i) break;
                            }
                            u = t;
                        }
                        a(!1, function() {
                            for(var t = 0, r = 0, e = 0; e < 8; e += 1){
                                a(!0, e);
                                var n = m.getLostPoint(h);
                                (0 == e || n < t) && (t = n, r = e);
                            }
                            return r;
                        }());
                    }, h.createTableTag = function(t, r) {
                        t = t || 2;
                        var e = "";
                        e += '<table style="', e += " border-width: 0px; border-style: none;", e += " border-collapse: collapse;", e += " padding: 0px; margin: " + (r = void 0 === r ? 4 * t : r) + "px;", e += '">', e += "<tbody>";
                        for(var n = 0; n < h.getModuleCount(); n += 1){
                            e += "<tr>";
                            for(var o = 0; o < h.getModuleCount(); o += 1)e += '<td style="', e += " border-width: 0px; border-style: none;", e += " border-collapse: collapse;", e += " padding: 0px; margin: 0px;", e += " width: " + t + "px;", e += " height: " + t + "px;", e += " background-color: ", e += h.isDark(n, o) ? "#000000" : "#ffffff", e += ";", e += '"/>';
                            e += "</tr>";
                        }
                        return e += "</tbody>", e += "</table>";
                    }, h.createSvgTag = function(t, r, e, n) {
                        var o = {};
                        "object" == typeof arguments[0] && (t = (o = arguments[0]).cellSize, r = o.margin, e = o.alt, n = o.title), t = t || 2, r = void 0 === r ? 4 * t : r, (e = "string" == typeof e ? {
                            text: e
                        } : e || {}).text = e.text || null, e.id = e.text ? e.id || "qrcode-description" : null, (n = "string" == typeof n ? {
                            text: n
                        } : n || {}).text = n.text || null, n.id = n.text ? n.id || "qrcode-title" : null;
                        var i, a, u, f = h.getModuleCount() * t + 2 * r, l = "", c = "l" + t + ",0 0," + t + " -" + t + ",0 0,-" + t + "z ";
                        for(l += '<svg version="1.1" xmlns="http://www.w3.org/2000/svg"', l += o.scalable ? "" : ' width="' + f + 'px" height="' + f + 'px"', l += ' viewBox="0 0 ' + f + " " + f + '" ', l += ' preserveAspectRatio="xMinYMin meet"', l += n.text || e.text ? ' role="img" aria-labelledby="' + w([
                            n.id,
                            e.id
                        ].join(" ").trim()) + '"' : "", l += ">", l += n.text ? '<title id="' + w(n.id) + '">' + w(n.text) + "</title>" : "", l += e.text ? '<description id="' + w(e.id) + '">' + w(e.text) + "</description>" : "", l += '<rect width="100%" height="100%" fill="white" cx="0" cy="0"/>', l += '<path d="', a = 0; a < h.getModuleCount(); a += 1)for(u = a * t + r, i = 0; i < h.getModuleCount(); i += 1)h.isDark(a, i) && (l += "M" + (i * t + r) + "," + u + c);
                        return l += '" stroke="transparent" fill="black"/>', l += "</svg>";
                    }, h.createDataURL = function(o, t) {
                        o = o || 2, t = void 0 === t ? 4 * o : t;
                        var r = h.getModuleCount() * o + 2 * t, i = t, a = r - t;
                        return P(r, r, function(t, r) {
                            if (i <= t && t < a && i <= r && r < a) {
                                var e = Math.floor((t - i) / o), n = Math.floor((r - i) / o);
                                return h.isDark(n, e) ? 0 : 1;
                            }
                            return 1;
                        });
                    }, h.createImgTag = function(t, r, e) {
                        t = t || 2, r = void 0 === r ? 4 * t : r;
                        var n = h.getModuleCount() * t + 2 * r, o = "";
                        return o += "<img", o += ' src="', o += h.createDataURL(t, r), o += '"', o += ' width="', o += n, o += '"', o += ' height="', o += n, o += '"', e && (o += ' alt="', o += w(e), o += '"'), o += "/>";
                    };
                    var w = function(t) {
                        for(var r = "", e = 0; e < t.length; e += 1){
                            var n = t.charAt(e);
                            switch(n){
                                case "<":
                                    r += "&lt;";
                                    break;
                                case ">":
                                    r += "&gt;";
                                    break;
                                case "&":
                                    r += "&amp;";
                                    break;
                                case '"':
                                    r += "&quot;";
                                    break;
                                default:
                                    r += n;
                            }
                        }
                        return r;
                    };
                    return h.createASCII = function(t, r) {
                        if ((t = t || 1) < 2) return function(t) {
                            t = void 0 === t ? 2 : t;
                            for(var r, e, n, o, i = +h.getModuleCount() + 2 * t, a = t, u = i - t, f = {
                                "██": "█",
                                "█ ": "▀",
                                " █": "▄",
                                "  ": " "
                            }, l = {
                                "██": "▀",
                                "█ ": "▀",
                                " █": " ",
                                "  ": " "
                            }, c = "", g = 0; g < i; g += 2){
                                for(e = Math.floor(g - a), n = Math.floor(g + 1 - a), r = 0; r < i; r += 1)o = "█", a <= r && r < u && a <= g && g < u && h.isDark(e, Math.floor(r - a)) && (o = " "), a <= r && r < u && a <= g + 1 && g + 1 < u && h.isDark(n, Math.floor(r - a)) ? o += " " : o += "█", c += t < 1 && u <= g + 1 ? l[o] : f[o];
                                c += "\n";
                            }
                            return i % 2 && 0 < t ? c.substring(0, c.length - i - 1) + Array(1 + i).join("▀") : c.substring(0, c.length - 1);
                        }(r);
                        --t, r = void 0 === r ? 2 * t : r;
                        for(var e, n, o, i = h.getModuleCount() * t + 2 * r, a = r, u = i - r, f = Array(t + 1).join("██"), l = Array(t + 1).join("  "), c = "", g = "", s = 0; s < i; s += 1){
                            for(n = Math.floor((s - a) / t), g = "", e = 0; e < i; e += 1)o = 1, a <= e && e < u && a <= s && s < u && h.isDark(n, Math.floor((e - a) / t)) && (o = 0), g += o ? f : l;
                            for(n = 0; n < t; n += 1)c += g + "\n";
                        }
                        return c.substring(0, c.length - 1);
                    }, h.renderTo2dContext = function(t, r) {
                        r = r || 2;
                        for(var e = h.getModuleCount(), n = 0; n < e; n++)for(var o = 0; o < e; o++)t.fillStyle = h.isDark(n, o) ? "black" : "white", t.fillRect(n * r, o * r, r, r);
                    }, h;
                }
                i.stringToBytes = (i.stringToBytesFuncs = {
                    default: function(t) {
                        for(var r = [], e = 0; e < t.length; e += 1){
                            var n = t.charCodeAt(e);
                            r.push(255 & n);
                        }
                        return r;
                    }
                }).default, i.createStringToBytes = function(u, f) {
                    var i = function() {
                        function t() {
                            var t = r.read();
                            if (-1 == t) throw "eof";
                            return t;
                        }
                        for(var r = z(u), e = 0, n = {};;){
                            var o = r.read();
                            if (-1 == o) break;
                            var i = t(), a = t() << 8 | t();
                            n[String.fromCharCode(o << 8 | i)] = a, e += 1;
                        }
                        if (e != f) throw e + " != " + f;
                        return n;
                    }(), a = "?".charCodeAt(0);
                    return function(t) {
                        for(var r = [], e = 0; e < t.length; e += 1){
                            var n, o = t.charCodeAt(e);
                            o < 128 ? r.push(o) : "number" == typeof (n = i[t.charAt(e)]) ? (255 & n) == n ? r.push(n) : (r.push(n >>> 8), r.push(255 & n)) : r.push(a);
                        }
                        return r;
                    };
                };
                var r, t, a = 1, u = 2, o = 4, f = 8, y = {
                    L: 1,
                    M: 0,
                    Q: 3,
                    H: 2
                }, e = 0, n = 1, l = 2, c = 3, g = 4, s = 5, h = 6, d = 7, m = (r = [
                    [],
                    [
                        6,
                        18
                    ],
                    [
                        6,
                        22
                    ],
                    [
                        6,
                        26
                    ],
                    [
                        6,
                        30
                    ],
                    [
                        6,
                        34
                    ],
                    [
                        6,
                        22,
                        38
                    ],
                    [
                        6,
                        24,
                        42
                    ],
                    [
                        6,
                        26,
                        46
                    ],
                    [
                        6,
                        28,
                        50
                    ],
                    [
                        6,
                        30,
                        54
                    ],
                    [
                        6,
                        32,
                        58
                    ],
                    [
                        6,
                        34,
                        62
                    ],
                    [
                        6,
                        26,
                        46,
                        66
                    ],
                    [
                        6,
                        26,
                        48,
                        70
                    ],
                    [
                        6,
                        26,
                        50,
                        74
                    ],
                    [
                        6,
                        30,
                        54,
                        78
                    ],
                    [
                        6,
                        30,
                        56,
                        82
                    ],
                    [
                        6,
                        30,
                        58,
                        86
                    ],
                    [
                        6,
                        34,
                        62,
                        90
                    ],
                    [
                        6,
                        28,
                        50,
                        72,
                        94
                    ],
                    [
                        6,
                        26,
                        50,
                        74,
                        98
                    ],
                    [
                        6,
                        30,
                        54,
                        78,
                        102
                    ],
                    [
                        6,
                        28,
                        54,
                        80,
                        106
                    ],
                    [
                        6,
                        32,
                        58,
                        84,
                        110
                    ],
                    [
                        6,
                        30,
                        58,
                        86,
                        114
                    ],
                    [
                        6,
                        34,
                        62,
                        90,
                        118
                    ],
                    [
                        6,
                        26,
                        50,
                        74,
                        98,
                        122
                    ],
                    [
                        6,
                        30,
                        54,
                        78,
                        102,
                        126
                    ],
                    [
                        6,
                        26,
                        52,
                        78,
                        104,
                        130
                    ],
                    [
                        6,
                        30,
                        56,
                        82,
                        108,
                        134
                    ],
                    [
                        6,
                        34,
                        60,
                        86,
                        112,
                        138
                    ],
                    [
                        6,
                        30,
                        58,
                        86,
                        114,
                        142
                    ],
                    [
                        6,
                        34,
                        62,
                        90,
                        118,
                        146
                    ],
                    [
                        6,
                        30,
                        54,
                        78,
                        102,
                        126,
                        150
                    ],
                    [
                        6,
                        24,
                        50,
                        76,
                        102,
                        128,
                        154
                    ],
                    [
                        6,
                        28,
                        54,
                        80,
                        106,
                        132,
                        158
                    ],
                    [
                        6,
                        32,
                        58,
                        84,
                        110,
                        136,
                        162
                    ],
                    [
                        6,
                        26,
                        54,
                        82,
                        110,
                        138,
                        166
                    ],
                    [
                        6,
                        30,
                        58,
                        86,
                        114,
                        142,
                        170
                    ]
                ], (t = {}).getBCHTypeInfo = function(t) {
                    for(var r = t << 10; 0 <= v(r) - v(1335);)r ^= 1335 << v(r) - v(1335);
                    return 21522 ^ (t << 10 | r);
                }, t.getBCHTypeNumber = function(t) {
                    for(var r = t << 12; 0 <= v(r) - v(7973);)r ^= 7973 << v(r) - v(7973);
                    return t << 12 | r;
                }, t.getPatternPosition = function(t) {
                    return r[t - 1];
                }, t.getMaskFunction = function(t) {
                    switch(t){
                        case e:
                            return function(t, r) {
                                return (t + r) % 2 == 0;
                            };
                        case n:
                            return function(t, r) {
                                return t % 2 == 0;
                            };
                        case l:
                            return function(t, r) {
                                return r % 3 == 0;
                            };
                        case c:
                            return function(t, r) {
                                return (t + r) % 3 == 0;
                            };
                        case g:
                            return function(t, r) {
                                return (Math.floor(t / 2) + Math.floor(r / 3)) % 2 == 0;
                            };
                        case s:
                            return function(t, r) {
                                return t * r % 2 + t * r % 3 == 0;
                            };
                        case h:
                            return function(t, r) {
                                return (t * r % 2 + t * r % 3) % 2 == 0;
                            };
                        case d:
                            return function(t, r) {
                                return (t * r % 3 + (t + r) % 2) % 2 == 0;
                            };
                        default:
                            throw "bad maskPattern:" + t;
                    }
                }, t.getErrorCorrectPolynomial = function(t) {
                    for(var r = b([
                        1
                    ], 0), e = 0; e < t; e += 1)r = r.multiply(b([
                        1,
                        p.gexp(e)
                    ], 0));
                    return r;
                }, t.getLengthInBits = function(t, r) {
                    if (1 <= r && r < 10) switch(t){
                        case a:
                            return 10;
                        case u:
                            return 9;
                        case o:
                        case f:
                            return 8;
                        default:
                            throw "mode:" + t;
                    }
                    else if (r < 27) switch(t){
                        case a:
                            return 12;
                        case u:
                            return 11;
                        case o:
                            return 16;
                        case f:
                            return 10;
                        default:
                            throw "mode:" + t;
                    }
                    else {
                        if (!(r < 41)) throw "type:" + r;
                        switch(t){
                            case a:
                                return 14;
                            case u:
                                return 13;
                            case o:
                                return 16;
                            case f:
                                return 12;
                            default:
                                throw "mode:" + t;
                        }
                    }
                }, t.getLostPoint = function(t) {
                    for(var r = t.getModuleCount(), e = 0, n = 0; n < r; n += 1)for(var o = 0; o < r; o += 1){
                        for(var i = 0, a = t.isDark(n, o), u = -1; u <= 1; u += 1)if (!(n + u < 0 || r <= n + u)) for(var f = -1; f <= 1; f += 1)o + f < 0 || r <= o + f || 0 == u && 0 == f || a == t.isDark(n + u, o + f) && (i += 1);
                        5 < i && (e += 3 + i - 5);
                    }
                    for(n = 0; n < r - 1; n += 1)for(o = 0; o < r - 1; o += 1){
                        var l = 0;
                        t.isDark(n, o) && (l += 1), t.isDark(n + 1, o) && (l += 1), t.isDark(n, o + 1) && (l += 1), t.isDark(n + 1, o + 1) && (l += 1), 0 != l && 4 != l || (e += 3);
                    }
                    for(n = 0; n < r; n += 1)for(o = 0; o < r - 6; o += 1)t.isDark(n, o) && !t.isDark(n, o + 1) && t.isDark(n, o + 2) && t.isDark(n, o + 3) && t.isDark(n, o + 4) && !t.isDark(n, o + 5) && t.isDark(n, o + 6) && (e += 40);
                    for(o = 0; o < r; o += 1)for(n = 0; n < r - 6; n += 1)t.isDark(n, o) && !t.isDark(n + 1, o) && t.isDark(n + 2, o) && t.isDark(n + 3, o) && t.isDark(n + 4, o) && !t.isDark(n + 5, o) && t.isDark(n + 6, o) && (e += 40);
                    for(var c = 0, o = 0; o < r; o += 1)for(n = 0; n < r; n += 1)t.isDark(n, o) && (c += 1);
                    return e += Math.abs(100 * c / r / r - 50) / 5 * 10;
                }, t);
                function v(t) {
                    for(var r = 0; 0 != t;)r += 1, t >>>= 1;
                    return r;
                }
                var p = function() {
                    for(var r = new Array(256), e = new Array(256), t = 0; t < 8; t += 1)r[t] = 1 << t;
                    for(t = 8; t < 256; t += 1)r[t] = r[t - 4] ^ r[t - 5] ^ r[t - 6] ^ r[t - 8];
                    for(t = 0; t < 255; t += 1)e[r[t]] = t;
                    var n = {
                        glog: function(t) {
                            if (t < 1) throw "glog(" + t + ")";
                            return e[t];
                        },
                        gexp: function(t) {
                            for(; t < 0;)t += 255;
                            for(; 256 <= t;)t -= 255;
                            return r[t];
                        }
                    };
                    return n;
                }();
                function b(n, o) {
                    if (void 0 === n.length) throw n.length + "/" + o;
                    var r = function() {
                        for(var t = 0; t < n.length && 0 == n[t];)t += 1;
                        for(var r = new Array(n.length - t + o), e = 0; e < n.length - t; e += 1)r[e] = n[e + t];
                        return r;
                    }(), i = {
                        getAt: function(t) {
                            return r[t];
                        },
                        getLength: function() {
                            return r.length;
                        },
                        multiply: function(t) {
                            for(var r = new Array(i.getLength() + t.getLength() - 1), e = 0; e < i.getLength(); e += 1)for(var n = 0; n < t.getLength(); n += 1)r[e + n] ^= p.gexp(p.glog(i.getAt(e)) + p.glog(t.getAt(n)));
                            return b(r, 0);
                        },
                        mod: function(t) {
                            if (i.getLength() - t.getLength() < 0) return i;
                            for(var r = p.glog(i.getAt(0)) - p.glog(t.getAt(0)), e = new Array(i.getLength()), n = 0; n < i.getLength(); n += 1)e[n] = i.getAt(n);
                            for(n = 0; n < t.getLength(); n += 1)e[n] ^= p.gexp(p.glog(t.getAt(n)) + r);
                            return b(e, 0).mod(t);
                        }
                    };
                    return i;
                }
                function w() {
                    var e = [], o = {
                        writeByte: function(t) {
                            e.push(255 & t);
                        },
                        writeShort: function(t) {
                            o.writeByte(t), o.writeByte(t >>> 8);
                        },
                        writeBytes: function(t, r, e) {
                            r = r || 0, e = e || t.length;
                            for(var n = 0; n < e; n += 1)o.writeByte(t[n + r]);
                        },
                        writeString: function(t) {
                            for(var r = 0; r < t.length; r += 1)o.writeByte(t.charCodeAt(r));
                        },
                        toByteArray: function() {
                            return e;
                        },
                        toString: function() {
                            var t = "";
                            t += "[";
                            for(var r = 0; r < e.length; r += 1)0 < r && (t += ","), t += e[r];
                            return t += "]";
                        }
                    };
                    return o;
                }
                function k() {
                    function e(t) {
                        a += String.fromCharCode(r(63 & t));
                    }
                    var n = 0, o = 0, i = 0, a = "", t = {}, r = function(t) {
                        if (!(t < 0)) {
                            if (t < 26) return 65 + t;
                            if (t < 52) return t - 26 + 97;
                            if (t < 62) return t - 52 + 48;
                            if (62 == t) return 43;
                            if (63 == t) return 47;
                        }
                        throw "n:" + t;
                    };
                    return t.writeByte = function(t) {
                        for(n = n << 8 | 255 & t, o += 8, i += 1; 6 <= o;)e(n >>> o - 6), o -= 6;
                    }, t.flush = function() {
                        if (0 < o && (e(n << 6 - o), o = n = 0), i % 3 != 0) for(var t = 3 - i % 3, r = 0; r < t; r += 1)a += "=";
                    }, t.toString = function() {
                        return a;
                    }, t;
                }
                function x(t, r) {
                    var n = t, o = r, d = new Array(t * r), e = {
                        setPixel: function(t, r, e) {
                            d[r * n + t] = e;
                        },
                        write: function(t) {
                            t.writeString("GIF87a"), t.writeShort(n), t.writeShort(o), t.writeByte(128), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(0), t.writeByte(255), t.writeByte(255), t.writeByte(255), t.writeString(","), t.writeShort(0), t.writeShort(0), t.writeShort(n), t.writeShort(o), t.writeByte(0);
                            var r = i(2);
                            t.writeByte(2);
                            for(var e = 0; 255 < r.length - e;)t.writeByte(255), t.writeBytes(r, e, 255), e += 255;
                            t.writeByte(r.length - e), t.writeBytes(r, e, r.length - e), t.writeByte(0), t.writeString(";");
                        }
                    }, i = function(t) {
                        for(var r = 1 << t, e = 1 + (1 << t), n = t + 1, o = v(), i = 0; i < r; i += 1)o.add(String.fromCharCode(i));
                        o.add(String.fromCharCode(r)), o.add(String.fromCharCode(e));
                        var a, u, f, l = w(), c = (a = l, f = u = 0, {
                            write: function(t, r) {
                                if (t >>> r != 0) throw "length over";
                                for(; 8 <= u + r;)a.writeByte(255 & (t << u | f)), r -= 8 - u, t >>>= 8 - u, u = f = 0;
                                f |= t << u, u += r;
                            },
                            flush: function() {
                                0 < u && a.writeByte(f);
                            }
                        });
                        c.write(r, n);
                        var g = 0, s = String.fromCharCode(d[g]);
                        for(g += 1; g < d.length;){
                            var h = String.fromCharCode(d[g]);
                            g += 1, o.contains(s + h) ? s += h : (c.write(o.indexOf(s), n), o.size() < 4095 && (o.size() == 1 << n && (n += 1), o.add(s + h)), s = h);
                        }
                        return c.write(o.indexOf(s), n), c.write(e, n), c.flush(), l.toByteArray();
                    }, v = function() {
                        var r = {}, e = 0, n = {
                            add: function(t) {
                                if (n.contains(t)) throw "dup key:" + t;
                                r[t] = e, e += 1;
                            },
                            size: function() {
                                return e;
                            },
                            indexOf: function(t) {
                                return r[t];
                            },
                            contains: function(t) {
                                return void 0 !== r[t];
                            }
                        };
                        return n;
                    };
                    return e;
                }
                var B, C, A = (B = [
                    [
                        1,
                        26,
                        19
                    ],
                    [
                        1,
                        26,
                        16
                    ],
                    [
                        1,
                        26,
                        13
                    ],
                    [
                        1,
                        26,
                        9
                    ],
                    [
                        1,
                        44,
                        34
                    ],
                    [
                        1,
                        44,
                        28
                    ],
                    [
                        1,
                        44,
                        22
                    ],
                    [
                        1,
                        44,
                        16
                    ],
                    [
                        1,
                        70,
                        55
                    ],
                    [
                        1,
                        70,
                        44
                    ],
                    [
                        2,
                        35,
                        17
                    ],
                    [
                        2,
                        35,
                        13
                    ],
                    [
                        1,
                        100,
                        80
                    ],
                    [
                        2,
                        50,
                        32
                    ],
                    [
                        2,
                        50,
                        24
                    ],
                    [
                        4,
                        25,
                        9
                    ],
                    [
                        1,
                        134,
                        108
                    ],
                    [
                        2,
                        67,
                        43
                    ],
                    [
                        2,
                        33,
                        15,
                        2,
                        34,
                        16
                    ],
                    [
                        2,
                        33,
                        11,
                        2,
                        34,
                        12
                    ],
                    [
                        2,
                        86,
                        68
                    ],
                    [
                        4,
                        43,
                        27
                    ],
                    [
                        4,
                        43,
                        19
                    ],
                    [
                        4,
                        43,
                        15
                    ],
                    [
                        2,
                        98,
                        78
                    ],
                    [
                        4,
                        49,
                        31
                    ],
                    [
                        2,
                        32,
                        14,
                        4,
                        33,
                        15
                    ],
                    [
                        4,
                        39,
                        13,
                        1,
                        40,
                        14
                    ],
                    [
                        2,
                        121,
                        97
                    ],
                    [
                        2,
                        60,
                        38,
                        2,
                        61,
                        39
                    ],
                    [
                        4,
                        40,
                        18,
                        2,
                        41,
                        19
                    ],
                    [
                        4,
                        40,
                        14,
                        2,
                        41,
                        15
                    ],
                    [
                        2,
                        146,
                        116
                    ],
                    [
                        3,
                        58,
                        36,
                        2,
                        59,
                        37
                    ],
                    [
                        4,
                        36,
                        16,
                        4,
                        37,
                        17
                    ],
                    [
                        4,
                        36,
                        12,
                        4,
                        37,
                        13
                    ],
                    [
                        2,
                        86,
                        68,
                        2,
                        87,
                        69
                    ],
                    [
                        4,
                        69,
                        43,
                        1,
                        70,
                        44
                    ],
                    [
                        6,
                        43,
                        19,
                        2,
                        44,
                        20
                    ],
                    [
                        6,
                        43,
                        15,
                        2,
                        44,
                        16
                    ],
                    [
                        4,
                        101,
                        81
                    ],
                    [
                        1,
                        80,
                        50,
                        4,
                        81,
                        51
                    ],
                    [
                        4,
                        50,
                        22,
                        4,
                        51,
                        23
                    ],
                    [
                        3,
                        36,
                        12,
                        8,
                        37,
                        13
                    ],
                    [
                        2,
                        116,
                        92,
                        2,
                        117,
                        93
                    ],
                    [
                        6,
                        58,
                        36,
                        2,
                        59,
                        37
                    ],
                    [
                        4,
                        46,
                        20,
                        6,
                        47,
                        21
                    ],
                    [
                        7,
                        42,
                        14,
                        4,
                        43,
                        15
                    ],
                    [
                        4,
                        133,
                        107
                    ],
                    [
                        8,
                        59,
                        37,
                        1,
                        60,
                        38
                    ],
                    [
                        8,
                        44,
                        20,
                        4,
                        45,
                        21
                    ],
                    [
                        12,
                        33,
                        11,
                        4,
                        34,
                        12
                    ],
                    [
                        3,
                        145,
                        115,
                        1,
                        146,
                        116
                    ],
                    [
                        4,
                        64,
                        40,
                        5,
                        65,
                        41
                    ],
                    [
                        11,
                        36,
                        16,
                        5,
                        37,
                        17
                    ],
                    [
                        11,
                        36,
                        12,
                        5,
                        37,
                        13
                    ],
                    [
                        5,
                        109,
                        87,
                        1,
                        110,
                        88
                    ],
                    [
                        5,
                        65,
                        41,
                        5,
                        66,
                        42
                    ],
                    [
                        5,
                        54,
                        24,
                        7,
                        55,
                        25
                    ],
                    [
                        11,
                        36,
                        12,
                        7,
                        37,
                        13
                    ],
                    [
                        5,
                        122,
                        98,
                        1,
                        123,
                        99
                    ],
                    [
                        7,
                        73,
                        45,
                        3,
                        74,
                        46
                    ],
                    [
                        15,
                        43,
                        19,
                        2,
                        44,
                        20
                    ],
                    [
                        3,
                        45,
                        15,
                        13,
                        46,
                        16
                    ],
                    [
                        1,
                        135,
                        107,
                        5,
                        136,
                        108
                    ],
                    [
                        10,
                        74,
                        46,
                        1,
                        75,
                        47
                    ],
                    [
                        1,
                        50,
                        22,
                        15,
                        51,
                        23
                    ],
                    [
                        2,
                        42,
                        14,
                        17,
                        43,
                        15
                    ],
                    [
                        5,
                        150,
                        120,
                        1,
                        151,
                        121
                    ],
                    [
                        9,
                        69,
                        43,
                        4,
                        70,
                        44
                    ],
                    [
                        17,
                        50,
                        22,
                        1,
                        51,
                        23
                    ],
                    [
                        2,
                        42,
                        14,
                        19,
                        43,
                        15
                    ],
                    [
                        3,
                        141,
                        113,
                        4,
                        142,
                        114
                    ],
                    [
                        3,
                        70,
                        44,
                        11,
                        71,
                        45
                    ],
                    [
                        17,
                        47,
                        21,
                        4,
                        48,
                        22
                    ],
                    [
                        9,
                        39,
                        13,
                        16,
                        40,
                        14
                    ],
                    [
                        3,
                        135,
                        107,
                        5,
                        136,
                        108
                    ],
                    [
                        3,
                        67,
                        41,
                        13,
                        68,
                        42
                    ],
                    [
                        15,
                        54,
                        24,
                        5,
                        55,
                        25
                    ],
                    [
                        15,
                        43,
                        15,
                        10,
                        44,
                        16
                    ],
                    [
                        4,
                        144,
                        116,
                        4,
                        145,
                        117
                    ],
                    [
                        17,
                        68,
                        42
                    ],
                    [
                        17,
                        50,
                        22,
                        6,
                        51,
                        23
                    ],
                    [
                        19,
                        46,
                        16,
                        6,
                        47,
                        17
                    ],
                    [
                        2,
                        139,
                        111,
                        7,
                        140,
                        112
                    ],
                    [
                        17,
                        74,
                        46
                    ],
                    [
                        7,
                        54,
                        24,
                        16,
                        55,
                        25
                    ],
                    [
                        34,
                        37,
                        13
                    ],
                    [
                        4,
                        151,
                        121,
                        5,
                        152,
                        122
                    ],
                    [
                        4,
                        75,
                        47,
                        14,
                        76,
                        48
                    ],
                    [
                        11,
                        54,
                        24,
                        14,
                        55,
                        25
                    ],
                    [
                        16,
                        45,
                        15,
                        14,
                        46,
                        16
                    ],
                    [
                        6,
                        147,
                        117,
                        4,
                        148,
                        118
                    ],
                    [
                        6,
                        73,
                        45,
                        14,
                        74,
                        46
                    ],
                    [
                        11,
                        54,
                        24,
                        16,
                        55,
                        25
                    ],
                    [
                        30,
                        46,
                        16,
                        2,
                        47,
                        17
                    ],
                    [
                        8,
                        132,
                        106,
                        4,
                        133,
                        107
                    ],
                    [
                        8,
                        75,
                        47,
                        13,
                        76,
                        48
                    ],
                    [
                        7,
                        54,
                        24,
                        22,
                        55,
                        25
                    ],
                    [
                        22,
                        45,
                        15,
                        13,
                        46,
                        16
                    ],
                    [
                        10,
                        142,
                        114,
                        2,
                        143,
                        115
                    ],
                    [
                        19,
                        74,
                        46,
                        4,
                        75,
                        47
                    ],
                    [
                        28,
                        50,
                        22,
                        6,
                        51,
                        23
                    ],
                    [
                        33,
                        46,
                        16,
                        4,
                        47,
                        17
                    ],
                    [
                        8,
                        152,
                        122,
                        4,
                        153,
                        123
                    ],
                    [
                        22,
                        73,
                        45,
                        3,
                        74,
                        46
                    ],
                    [
                        8,
                        53,
                        23,
                        26,
                        54,
                        24
                    ],
                    [
                        12,
                        45,
                        15,
                        28,
                        46,
                        16
                    ],
                    [
                        3,
                        147,
                        117,
                        10,
                        148,
                        118
                    ],
                    [
                        3,
                        73,
                        45,
                        23,
                        74,
                        46
                    ],
                    [
                        4,
                        54,
                        24,
                        31,
                        55,
                        25
                    ],
                    [
                        11,
                        45,
                        15,
                        31,
                        46,
                        16
                    ],
                    [
                        7,
                        146,
                        116,
                        7,
                        147,
                        117
                    ],
                    [
                        21,
                        73,
                        45,
                        7,
                        74,
                        46
                    ],
                    [
                        1,
                        53,
                        23,
                        37,
                        54,
                        24
                    ],
                    [
                        19,
                        45,
                        15,
                        26,
                        46,
                        16
                    ],
                    [
                        5,
                        145,
                        115,
                        10,
                        146,
                        116
                    ],
                    [
                        19,
                        75,
                        47,
                        10,
                        76,
                        48
                    ],
                    [
                        15,
                        54,
                        24,
                        25,
                        55,
                        25
                    ],
                    [
                        23,
                        45,
                        15,
                        25,
                        46,
                        16
                    ],
                    [
                        13,
                        145,
                        115,
                        3,
                        146,
                        116
                    ],
                    [
                        2,
                        74,
                        46,
                        29,
                        75,
                        47
                    ],
                    [
                        42,
                        54,
                        24,
                        1,
                        55,
                        25
                    ],
                    [
                        23,
                        45,
                        15,
                        28,
                        46,
                        16
                    ],
                    [
                        17,
                        145,
                        115
                    ],
                    [
                        10,
                        74,
                        46,
                        23,
                        75,
                        47
                    ],
                    [
                        10,
                        54,
                        24,
                        35,
                        55,
                        25
                    ],
                    [
                        19,
                        45,
                        15,
                        35,
                        46,
                        16
                    ],
                    [
                        17,
                        145,
                        115,
                        1,
                        146,
                        116
                    ],
                    [
                        14,
                        74,
                        46,
                        21,
                        75,
                        47
                    ],
                    [
                        29,
                        54,
                        24,
                        19,
                        55,
                        25
                    ],
                    [
                        11,
                        45,
                        15,
                        46,
                        46,
                        16
                    ],
                    [
                        13,
                        145,
                        115,
                        6,
                        146,
                        116
                    ],
                    [
                        14,
                        74,
                        46,
                        23,
                        75,
                        47
                    ],
                    [
                        44,
                        54,
                        24,
                        7,
                        55,
                        25
                    ],
                    [
                        59,
                        46,
                        16,
                        1,
                        47,
                        17
                    ],
                    [
                        12,
                        151,
                        121,
                        7,
                        152,
                        122
                    ],
                    [
                        12,
                        75,
                        47,
                        26,
                        76,
                        48
                    ],
                    [
                        39,
                        54,
                        24,
                        14,
                        55,
                        25
                    ],
                    [
                        22,
                        45,
                        15,
                        41,
                        46,
                        16
                    ],
                    [
                        6,
                        151,
                        121,
                        14,
                        152,
                        122
                    ],
                    [
                        6,
                        75,
                        47,
                        34,
                        76,
                        48
                    ],
                    [
                        46,
                        54,
                        24,
                        10,
                        55,
                        25
                    ],
                    [
                        2,
                        45,
                        15,
                        64,
                        46,
                        16
                    ],
                    [
                        17,
                        152,
                        122,
                        4,
                        153,
                        123
                    ],
                    [
                        29,
                        74,
                        46,
                        14,
                        75,
                        47
                    ],
                    [
                        49,
                        54,
                        24,
                        10,
                        55,
                        25
                    ],
                    [
                        24,
                        45,
                        15,
                        46,
                        46,
                        16
                    ],
                    [
                        4,
                        152,
                        122,
                        18,
                        153,
                        123
                    ],
                    [
                        13,
                        74,
                        46,
                        32,
                        75,
                        47
                    ],
                    [
                        48,
                        54,
                        24,
                        14,
                        55,
                        25
                    ],
                    [
                        42,
                        45,
                        15,
                        32,
                        46,
                        16
                    ],
                    [
                        20,
                        147,
                        117,
                        4,
                        148,
                        118
                    ],
                    [
                        40,
                        75,
                        47,
                        7,
                        76,
                        48
                    ],
                    [
                        43,
                        54,
                        24,
                        22,
                        55,
                        25
                    ],
                    [
                        10,
                        45,
                        15,
                        67,
                        46,
                        16
                    ],
                    [
                        19,
                        148,
                        118,
                        6,
                        149,
                        119
                    ],
                    [
                        18,
                        75,
                        47,
                        31,
                        76,
                        48
                    ],
                    [
                        34,
                        54,
                        24,
                        34,
                        55,
                        25
                    ],
                    [
                        20,
                        45,
                        15,
                        61,
                        46,
                        16
                    ]
                ], (C = {}).getRSBlocks = function(t, r) {
                    var e = function(t, r) {
                        switch(r){
                            case y.L:
                                return B[4 * (t - 1) + 0];
                            case y.M:
                                return B[4 * (t - 1) + 1];
                            case y.Q:
                                return B[4 * (t - 1) + 2];
                            case y.H:
                                return B[4 * (t - 1) + 3];
                            default:
                                return;
                        }
                    }(t, r);
                    if (void 0 === e) throw "bad rs block @ typeNumber:" + t + "/errorCorrectionLevel:" + r;
                    for(var n, o, i = e.length / 3, a = [], u = 0; u < i; u += 1)for(var f = e[3 * u + 0], l = e[3 * u + 1], c = e[3 * u + 2], g = 0; g < f; g += 1)a.push((n = c, o = void 0, (o = {}).totalCount = l, o.dataCount = n, o));
                    return a;
                }, C), M = function() {
                    var e = [], n = 0, o = {
                        getBuffer: function() {
                            return e;
                        },
                        getAt: function(t) {
                            var r = Math.floor(t / 8);
                            return 1 == (e[r] >>> 7 - t % 8 & 1);
                        },
                        put: function(t, r) {
                            for(var e = 0; e < r; e += 1)o.putBit(1 == (t >>> r - e - 1 & 1));
                        },
                        getLengthInBits: function() {
                            return n;
                        },
                        putBit: function(t) {
                            var r = Math.floor(n / 8);
                            e.length <= r && e.push(0), t && (e[r] |= 128 >>> n % 8), n += 1;
                        }
                    };
                    return o;
                }, S = function(t) {
                    var r = a, n = t, e = {
                        getMode: function() {
                            return r;
                        },
                        getLength: function(t) {
                            return n.length;
                        },
                        write: function(t) {
                            for(var r = n, e = 0; e + 2 < r.length;)t.put(o(r.substring(e, e + 3)), 10), e += 3;
                            e < r.length && (r.length - e == 1 ? t.put(o(r.substring(e, e + 1)), 4) : r.length - e == 2 && t.put(o(r.substring(e, e + 2)), 7));
                        }
                    }, o = function(t) {
                        for(var r = 0, e = 0; e < t.length; e += 1)r = 10 * r + i(t.charAt(e));
                        return r;
                    }, i = function(t) {
                        if ("0" <= t && t <= "9") return t.charCodeAt(0) - "0".charCodeAt(0);
                        throw "illegal char :" + t;
                    };
                    return e;
                }, L = function(t) {
                    var r = u, n = t, e = {
                        getMode: function() {
                            return r;
                        },
                        getLength: function(t) {
                            return n.length;
                        },
                        write: function(t) {
                            for(var r = n, e = 0; e + 1 < r.length;)t.put(45 * o(r.charAt(e)) + o(r.charAt(e + 1)), 11), e += 2;
                            e < r.length && t.put(o(r.charAt(e)), 6);
                        }
                    }, o = function(t) {
                        if ("0" <= t && t <= "9") return t.charCodeAt(0) - "0".charCodeAt(0);
                        if ("A" <= t && t <= "Z") return t.charCodeAt(0) - "A".charCodeAt(0) + 10;
                        switch(t){
                            case " ":
                                return 36;
                            case "$":
                                return 37;
                            case "%":
                                return 38;
                            case "*":
                                return 39;
                            case "+":
                                return 40;
                            case "-":
                                return 41;
                            case ".":
                                return 42;
                            case "/":
                                return 43;
                            case ":":
                                return 44;
                            default:
                                throw "illegal char :" + t;
                        }
                    };
                    return e;
                }, D = function(t) {
                    var r = o, e = i.stringToBytes(t), n = {
                        getMode: function() {
                            return r;
                        },
                        getLength: function(t) {
                            return e.length;
                        },
                        write: function(t) {
                            for(var r = 0; r < e.length; r += 1)t.put(e[r], 8);
                        }
                    };
                    return n;
                }, T = function(t) {
                    var r = f, e = i.stringToBytesFuncs.SJIS;
                    if (!e) throw "sjis not supported.";
                    !function() {
                        var t = e("友");
                        if (2 != t.length || 38726 != (t[0] << 8 | t[1])) throw "sjis not supported.";
                    }();
                    var o = e(t), n = {
                        getMode: function() {
                            return r;
                        },
                        getLength: function(t) {
                            return ~~(o.length / 2);
                        },
                        write: function(t) {
                            for(var r = o, e = 0; e + 1 < r.length;){
                                var n = (255 & r[e]) << 8 | 255 & r[e + 1];
                                if (33088 <= n && n <= 40956) n -= 33088;
                                else {
                                    if (!(57408 <= n && n <= 60351)) throw "illegal char at " + (e + 1) + "/" + n;
                                    n -= 49472;
                                }
                                n = 192 * (n >>> 8 & 255) + (255 & n), t.put(n, 13), e += 2;
                            }
                            if (e < r.length) throw "illegal char at " + (e + 1);
                        }
                    };
                    return n;
                }, z = function(t) {
                    var e = t, n = 0, o = 0, i = 0, r = {
                        read: function() {
                            for(; i < 8;){
                                if (n >= e.length) {
                                    if (0 == i) return -1;
                                    throw "unexpected end of file./" + i;
                                }
                                var t = e.charAt(n);
                                if (n += 1, "=" == t) return i = 0, -1;
                                t.match(/^\s$/) || (o = o << 6 | a(t.charCodeAt(0)), i += 6);
                            }
                            var r = o >>> i - 8 & 255;
                            return i -= 8, r;
                        }
                    }, a = function(t) {
                        if (65 <= t && t <= 90) return t - 65;
                        if (97 <= t && t <= 122) return t - 97 + 26;
                        if (48 <= t && t <= 57) return t - 48 + 52;
                        if (43 == t) return 62;
                        if (47 == t) return 63;
                        throw "c:" + t;
                    };
                    return r;
                }, P = function(t, r, e) {
                    for(var n = x(t, r), o = 0; o < r; o += 1)for(var i = 0; i < t; i += 1)n.setPixel(i, o, e(i, o));
                    var a = w();
                    n.write(a);
                    for(var u = k(), f = a.toByteArray(), l = 0; l < f.length; l += 1)u.writeByte(f[l]);
                    return u.flush(), "data:image/gif;base64," + u;
                };
                return i;
            }();
            a.stringToBytesFuncs["UTF-8"] = function(t) {
                return function(t) {
                    for(var r = [], e = 0; e < t.length; e++){
                        var n = t.charCodeAt(e);
                        n < 128 ? r.push(n) : n < 2048 ? r.push(192 | n >> 6, 128 | 63 & n) : n < 55296 || 57344 <= n ? r.push(224 | n >> 12, 128 | n >> 6 & 63, 128 | 63 & n) : (e++, n = 65536 + ((1023 & n) << 10 | 1023 & t.charCodeAt(e)), r.push(240 | n >> 18, 128 | n >> 12 & 63, 128 | n >> 6 & 63, 128 | 63 & n));
                    }
                    return r;
                }(t);
            }, o = [], void 0 === (i = "function" == typeof (n = function() {
                return a;
            }) ? n.apply(r, o) : n) || (t.exports = i);
        }
    ], o.c = n, o.d = function(t, r, e) {
        o.o(t, r) || Object.defineProperty(t, r, {
            enumerable: !0,
            get: e
        });
    }, o.r = function(t) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(t, "__esModule", {
            value: !0
        });
    }, o.t = function(r, t) {
        if (1 & t && (r = o(r)), 8 & t) return r;
        if (4 & t && "object" == typeof r && r && r.__esModule) return r;
        var e = Object.create(null);
        if (o.r(e), Object.defineProperty(e, "default", {
            enumerable: !0,
            value: r
        }), 2 & t && "string" != typeof r) for(var n in r)o.d(e, n, (function(t) {
            return r[t];
        }).bind(null, n));
        return e;
    }, o.n = function(t) {
        var r = t && t.__esModule ? function() {
            return t.default;
        } : function() {
            return t;
        };
        return o.d(r, "a", r), r;
    }, o.o = function(t, r) {
        return Object.prototype.hasOwnProperty.call(t, r);
    }, o.p = "", o(o.s = 0);
    function o(t) {
        if (n[t]) return n[t].exports;
        var r = n[t] = {
            i: t,
            l: !1,
            exports: {}
        };
        return e[t].call(r.exports, r, r.exports, o), r.l = !0, r.exports;
    }
});


/*! Copyright (c) 2011 Piotr Rochala (http://rocha.la)
 * Dual licensed under the MIT (http://www.opensource.org/licenses/mit-license.php)
 * and GPL (http://www.opensource.org/licenses/gpl-license.php) licenses.
 *
 * Version: 1.3.8
 *
 */ (function(e) {
    e.fn.extend({
        slimScroll: function(f) {
            var a = e.extend({
                width: "auto",
                height: "250px",
                size: "7px",
                color: "#000",
                position: "right",
                distance: "1px",
                start: "top",
                opacity: .4,
                alwaysVisible: !1,
                disableFadeOut: !1,
                railVisible: !1,
                railColor: "#333",
                railOpacity: .2,
                railDraggable: !0,
                railClass: "slimScrollRail",
                barClass: "slimScrollBar",
                wrapperClass: "slimScrollDiv",
                allowPageScroll: !1,
                wheelStep: 20,
                touchScrollStep: 200,
                borderRadius: "7px",
                railBorderRadius: "7px"
            }, f);
            this.each(function() {
                function v(d) {
                    if (r) {
                        d = d || window.event;
                        var c = 0;
                        d.wheelDelta && (c = -d.wheelDelta / 120);
                        d.detail && (c = d.detail / 3);
                        e(d.target || d.srcTarget || d.srcElement).closest("." + a.wrapperClass).is(b.parent()) && n(c, !0);
                        d.preventDefault && !k && d.preventDefault();
                        k || (d.returnValue = !1);
                    }
                }
                function n(d, g, e) {
                    k = !1;
                    var f = b.outerHeight() - c.outerHeight();
                    g && (g = parseInt(c.css("top")) + d * parseInt(a.wheelStep) / 100 * c.outerHeight(), g = Math.min(Math.max(g, 0), f), g = 0 < d ? Math.ceil(g) : Math.floor(g), c.css({
                        top: g + "px"
                    }));
                    l = parseInt(c.css("top")) / (b.outerHeight() - c.outerHeight());
                    g = l * (b[0].scrollHeight - b.outerHeight());
                    e && (g = d, d = g / b[0].scrollHeight * b.outerHeight(), d = Math.min(Math.max(d, 0), f), c.css({
                        top: d + "px"
                    }));
                    b.scrollTop(g);
                    b.trigger("slimscrolling", ~~g);
                    w();
                    p();
                }
                function x() {
                    u = Math.max(b.outerHeight() / b[0].scrollHeight * b.outerHeight(), 30);
                    c.css({
                        height: u + "px"
                    });
                    var a = u == b.outerHeight() ? "none" : "block";
                    c.css({
                        display: a
                    });
                }
                function w() {
                    x();
                    clearTimeout(B);
                    l == ~~l ? (k = a.allowPageScroll, C != l && b.trigger("slimscroll", 0 == ~~l ? "top" : "bottom")) : k = !1;
                    C = l;
                    u >= b.outerHeight() ? k = !0 : (c.stop(!0, !0).fadeIn("fast"), a.railVisible && m.stop(!0, !0).fadeIn("fast"));
                }
                function p() {
                    a.alwaysVisible || (B = setTimeout(function() {
                        a.disableFadeOut && r || y || z || (c.fadeOut("slow"), m.fadeOut("slow"));
                    }, 1E3));
                }
                var r, y, z, B, A, u, l, C, k = !1, b = e(this);
                if (b.parent().hasClass(a.wrapperClass)) {
                    var q = b.scrollTop(), c = b.siblings("." + a.barClass), m = b.siblings("." + a.railClass);
                    x();
                    if (e.isPlainObject(f)) {
                        if ("height" in f && "auto" == f.height) {
                            b.parent().css("height", "auto");
                            b.css("height", "auto");
                            var h = b.parent().parent().height();
                            b.parent().css("height", h);
                            b.css("height", h);
                        } else "height" in f && (h = f.height, b.parent().css("height", h), b.css("height", h));
                        if ("scrollTo" in f) q = parseInt(a.scrollTo);
                        else if ("scrollBy" in f) q += parseInt(a.scrollBy);
                        else if ("destroy" in f) {
                            c.remove();
                            m.remove();
                            b.unwrap();
                            return;
                        }
                        n(q, !1, !0);
                    }
                } else if (!(e.isPlainObject(f) && "destroy" in f)) {
                    a.height = "auto" == a.height ? b.parent().height() : a.height;
                    q = e("<div></div>").addClass(a.wrapperClass).css({
                        position: "relative",
                        overflow: "hidden",
                        width: a.width,
                        height: a.height
                    });
                    b.css({
                        overflow: "hidden",
                        width: a.width,
                        height: a.height
                    });
                    var m = e("<div></div>").addClass(a.railClass).css({
                        width: a.size,
                        height: "100%",
                        position: "absolute",
                        top: 0,
                        display: a.alwaysVisible && a.railVisible ? "block" : "none",
                        "border-radius": a.railBorderRadius,
                        background: a.railColor,
                        opacity: a.railOpacity,
                        zIndex: 90
                    }), c = e("<div></div>").addClass(a.barClass).css({
                        background: a.color,
                        width: a.size,
                        position: "absolute",
                        top: 0,
                        opacity: a.opacity,
                        display: a.alwaysVisible ? "block" : "none",
                        "border-radius": a.borderRadius,
                        BorderRadius: a.borderRadius,
                        MozBorderRadius: a.borderRadius,
                        WebkitBorderRadius: a.borderRadius,
                        zIndex: 99
                    }), h = "right" == a.position ? {
                        right: a.distance
                    } : {
                        left: a.distance
                    };
                    m.css(h);
                    c.css(h);
                    b.wrap(q);
                    b.parent().append(c);
                    b.parent().append(m);
                    a.railDraggable && c.bind("mousedown", function(a) {
                        var b = e(document);
                        z = !0;
                        t = parseFloat(c.css("top"));
                        pageY = a.pageY;
                        b.bind("mousemove.slimscroll", function(a) {
                            currTop = t + a.pageY - pageY;
                            c.css("top", currTop);
                            n(0, c.position().top, !1);
                        });
                        b.bind("mouseup.slimscroll", function(a) {
                            z = !1;
                            p();
                            b.unbind(".slimscroll");
                        });
                        return !1;
                    }).bind("selectstart.slimscroll", function(a) {
                        a.stopPropagation();
                        a.preventDefault();
                        return !1;
                    });
                    m.hover(function() {
                        w();
                    }, function() {
                        p();
                    });
                    c.hover(function() {
                        y = !0;
                    }, function() {
                        y = !1;
                    });
                    b.hover(function() {
                        r = !0;
                        w();
                        p();
                    }, function() {
                        r = !1;
                        p();
                    });
                    b.bind("touchstart", function(a, b) {
                        a.originalEvent.touches.length && (A = a.originalEvent.touches[0].pageY);
                    });
                    b.bind("touchmove", function(b) {
                        k || b.originalEvent.preventDefault();
                        b.originalEvent.touches.length && (n((A - b.originalEvent.touches[0].pageY) / a.touchScrollStep, !0), A = b.originalEvent.touches[0].pageY);
                    });
                    x();
                    "bottom" === a.start ? (c.css({
                        top: b.outerHeight() - c.outerHeight()
                    }), n(0, !0)) : "top" !== a.start && (n(e(a.start).position().top, null, !0), a.alwaysVisible || c.hide());
                    window.addEventListener ? (this.addEventListener("DOMMouseScroll", v, !1), this.addEventListener("mousewheel", v, !1)) : document.attachEvent("onmousewheel", v);
                }
            });
            return this;
        }
    });
    e.fn.extend({
        slimscroll: e.fn.slimScroll
    });
})(jQuery);


/*
 Input Mask plugin binding
 http://github.com/RobinHerbots/jquery.inputmask
 Copyright (c) Robin Herbots
 Licensed under the MIT license
 */ (function(factory) {
    factory(jQuery, window.Inputmask, window);
})(function($, Inputmask, window1) {
    $(window1.document).ajaxComplete(function(event, xmlHttpRequest, ajaxOptions) {
        if ($.inArray("html", ajaxOptions.dataTypes) !== -1) $(".inputmask, [data-inputmask], [data-inputmask-mask], [data-inputmask-alias], [data-inputmask-regex]").each(function(ndx, lmnt) {
            if (lmnt.inputmask === undefined) Inputmask().mask(lmnt);
        });
    }).ready(function() {
        $(".inputmask, [data-inputmask], [data-inputmask-mask], [data-inputmask-alias],[data-inputmask-regex]").each(function(ndx, lmnt) {
            if (lmnt.inputmask === undefined) Inputmask().mask(lmnt);
        });
    });
});


(function() {
    var store = Vue.observable({
        viewport: null,
        openMenu: false,
        openCZNList: false,
        cznSelectMode: false,
        currentCzn: null,
        openForm: false,
        openPsihoForm: false,
        langTat: false,
        formSuccess: false,
        invalidMode: false,
        font: "normal",
        color: "white"
    });
    var actions = {
        setViewport: function(viewport) {
            store.viewport = viewport;
        },
        setOpenMenu: function(val) {
            store.openMenu = val;
        },
        setOpenCZNList: function(val, selectMode) {
            store.openCZNList = val;
            if (val && selectMode) store.cznSelectMode = true;
        },
        setCurrentCzn: function({ id: id , name: name  }) {
            store.currentCzn = {
                id: id,
                name: name
            };
        },
        setOpenForm: function(val) {
            store.openForm = val;
            if (!val) {
                store.cznSelectMode = false;
                store.currentCzn = null;
            }
        },
        setOpenPsihoForm: function(val) {
            store.openPsihoForm = val;
            if (!val) {
                store.cznSelectMode = false;
                store.currentCzn = null;
            }
        },
        setLangTat: function(val) {
            store.langTat = val;
        },
        setFormSuccess: function(val) {
            store.formSuccess = val;
        },
        setFont: function(val) {
            if (val && val !== "null") store.font = val;
        },
        setColor: function(val) {
            if (val && val !== "null") store.color = val;
        },
        setCookieInvalid: function(props) {
            if (props.invalidMode !== undefined) setCookie("invalid_version_default", !props.invalidMode, {
                expires: 10000
            });
            if (props.font !== undefined) setCookie("invalid_font", props.font, {
                expires: 10000
            });
            if (props.color !== undefined) setCookie("invalid_color", props.color, {
                expires: 10000
            });
        },
        setInitialInvalidSettings: function() {
            var color = Vue.$cookies.get("invalid_color");
            var font = Vue.$cookies.get("invalid_font");
            var invalidVersionDefault = Vue.$cookies.get("invalid_version_default");
            var invalidMode = invalidVersionDefault === "false";
            this.setFont(font);
            this.setColor(color && color !== "null" ? color.replace("-theme", "") : null);
            store.invalidMode = invalidMode;
            if (invalidVersionDefault === null) this.setCookieInvalid({
                invalidMode: false,
                font: store.font,
                color: store.color
            });
            if (invalidMode) this.setInvalidAttributes(store.font, store.color + "-theme");
        },
        setInvalidAttributes: function(font, color) {
            $("html").attr("class", font);
            $("body").attr("class", color);
        },
        setInvalidMode: function(val) {
            store.invalidMode = val;
            this.setCookieInvalid({
                invalidMode: val
            });
            if (!val) this.setInvalidAttributes("", "");
            else {
                this.changeFont(store.font, true);
                this.changeColor(store.color, true);
            }
        },
        resetInvalidSettings () {
            store.invalidMode = false;
            this.setInvalidAttributes("", "");
            this.setFont("normal");
            this.setColor("white");
            this.setCookieInvalid({
                invalidMode: false,
                font: "normal",
                color: "white"
            });
        },
        changeFont: function(font, withoutCookie) {
            var classes = "null sm normal lg";
            $("html").removeClass(classes.replace(font, ""));
            $("html").addClass(font);
            if (!withoutCookie) {
                this.setCookieInvalid({
                    font: font
                });
                this.setFont(font);
            }
        },
        changeColor: function(color, withoutCookie) {
            var classes = "null white-theme black-theme blue-theme";
            $("body").removeClass(classes.replace(color + "-theme", ""));
            $("body").addClass(color + "-theme");
            if (!withoutCookie) {
                this.setCookieInvalid({
                    color: color
                });
                this.setColor(color);
            }
        }
    };
    Vue.prototype.$store = store;
    Vue.prototype.$actions = actions;
})();


Vue.component("v-menu", {
    mounted: function() {
        var vm = this;
        var links = $(this.$el).find(".menu-sm__title");
        links.on("click", function() {
            if (vm.$store.viewport === "mobile") {
                $(this).siblings(".menu-sm__links").slideToggle().css({
                    display: "flex"
                });
                $(this).find(".menu-sm__arrow").toggleClass("menu-sm__arrow--opened");
            }
        });
    }
});


Vue.component("v-collapse", {
    data: function() {
        return {
            show: false
        };
    },
    methods: {
        toggle: function() {
            this.show = !this.show;
        }
    },
    template: `
    <div v-bind:class="['collapse', {'collapse--opened': show}]">
        <div class="collapse__head flex" v-on:click="toggle">
            <div class="collapse__name flex-auto">
                <div class="collapse--bounded">
                    <slot name="head"/>
                </div>
            </div>
            <div class="collapse__arrow flex-none">
                <svg width="24" height="12">
                    <use xlink:href="#svg-arrow-up-toggle-icon" />
                </svg>
            </div>
        </div>
        <transition name="collapse">
          <div v-if="show" class="collapse__content">
              <div>
                  <slot name="content"/>
              </div>
              <slot name="links"/>
          </div>
        </transition>
    </div>
  `
});


Vue.component("v-scroll-alphabet", {
    data: function() {
        return {
            delta: 0,
            position: 0,
            scrollWidth: 0
        };
    },
    mounted: function() {
        this.delta = this.$refs.scrollContainer.offsetWidth;
        this.scrollWidth = this.$refs.scrollContainer.scrollWidth;
    },
    methods: {
        scrollNext: function() {
            let pos = this.$refs.scrollContainer.scrollLeft;
            this.position = pos + this.delta;
            this.$refs.scrollContainer.scroll({
                left: this.position,
                behavior: "smooth"
            });
        },
        scrollPrev: function() {
            let pos = this.$refs.scrollContainer.scrollLeft;
            this.position = pos - this.delta;
            this.$refs.scrollContainer.scroll({
                left: this.position,
                behavior: "smooth"
            });
        }
    },
    computed: {
        disabledPrev () {
            return this.position <= 0;
        },
        disabledNext () {
            return this.position >= this.scrollWidth;
        }
    }
});


Vue.component("v-register-list", {
    data: function() {
        return {
            pageNumb: 10,
            table: null,
            loading: false,
            timeOut: 0,
            page: 1,
            paginationPages: 0,
            list: [],
            name: "",
            data: 1
        };
    },
    mounted: function() {
        $(document).keydown(function(e) {
            if (e.keyCode == 13) return false;
        });
        this.start("spec");
    },
    methods: {
        start (table) {
            this.table = table;
            this.getList({
                page_max: this.pageNumb,
                table: this.table
            });
        },
        getList (send, concat) {
            $.ajax({
                type: "POST",
                url: "ajax.php?act=getRegisterList",
                data: send,
                beforeSend: ()=>{
                    this.loading = true;
                },
                success: (data)=>{
                    this.loading = false;
                    this.list = concat ? this.list.concat(data.data.items) : data.data.items;
                    this.paginationPages = Math.ceil(data.data.num / this.pageNumb);
                }
            });
        },
        loadMore () {
            this.page = this.page + 1;
            this.getList({
                name: this.name,
                page_max: this.pageNumb,
                table: this.table,
                page: this.page
            }, true);
        },
        inputKeyup (e) {
            var name = e.target.value;
            if (name.length < 3 && e.keyCode !== 8 && e.keyCode !== 46) return false;
            this.name = name;
            clearTimeout(this.timeOut);
            var self = this;
            this.timeOut = setTimeout(()=>{
                self.page = 1;
                self.getList({
                    name: this.name,
                    page_max: self.pageNumb,
                    table: self.table
                });
            }, 2000);
        }
    }
});


var $ef42fe9aca28652f$var$AGE_GROUP = {};
var $ef42fe9aca28652f$var$STATUS = {
    default: 0,
    preretirement: 1,
    retirement: 2
};
var $ef42fe9aca28652f$var$SEX = {
    male: "male",
    female: "female"
};
const $ef42fe9aca28652f$var$MAX_PAY = 12792;
const $ef42fe9aca28652f$var$MIN_PAY = 1500;
$ef42fe9aca28652f$var$AGE_GROUP[$ef42fe9aca28652f$var$SEX.male] = [
    {
        label: "1958 и старше",
        preretirement: null,
        retirement: 60,
        value: 1958
    },
    {
        label: "1959",
        preretirement: 55.5,
        retirement: 60.5,
        value: 1959
    },
    {
        label: "1960",
        preretirement: 56.5,
        retirement: 61.5,
        value: 1960
    },
    {
        label: "1961",
        preretirement: 58,
        retirement: 63,
        value: 1961
    },
    {
        label: "1962",
        preretirement: 59,
        retirement: 64,
        value: 1962
    },
    {
        label: "1963 и младше",
        preretirement: 60,
        retirement: 65,
        value: 1963
    }
].sort(function(a, b) {
    return b.value - a.value;
});
$ef42fe9aca28652f$var$AGE_GROUP[$ef42fe9aca28652f$var$SEX.female] = [
    {
        label: "1963 и старше",
        preretirement: null,
        retirement: 55,
        value: 1963
    },
    {
        label: "1964",
        preretirement: 50.5,
        retirement: 55.5,
        value: 1964
    },
    {
        label: "1965",
        preretirement: 51.5,
        retirement: 56.5,
        value: 1965
    },
    {
        label: "1966",
        preretirement: 53,
        retirement: 58,
        value: 1966
    },
    {
        label: "1967",
        preretirement: 54,
        retirement: 59,
        value: 1967
    },
    {
        label: "1968 и младше",
        preretirement: 55,
        retirement: 60,
        value: 1968
    }
].sort(function(a, b) {
    return b.value - a.value;
});
var $ef42fe9aca28652f$var$REASON = [
    {
        value: 1,
        label: "Ранее не работал"
    },
    {
        value: 2,
        label: "Завершил предпринимательскую деятельность или вышел из членов крестьянского (фермерского) хозяйства"
    },
    {
        value: 3,
        label: "Уволен за нарушения трудовой дисциплины"
    },
    {
        value: 4,
        label: "Уволен менее года назад и был в трудовых отношениях не менее 26-и недель"
    },
    {
        value: 5,
        label: "Уволен более года назад, в том числе с военной службы"
    },
    {
        value: 6,
        label: "Уволен с военной службы менее года назад и был в трудовых отношениях не менее 26-и недель в течение года до призыва"
    }
];
Vue.component("v-calcposobie", {
    data: function() {
        return {
            SEX: $ef42fe9aca28652f$var$SEX,
            STATUS: $ef42fe9aca28652f$var$STATUS,
            AGE_GROUP: $ef42fe9aca28652f$var$AGE_GROUP,
            REASON: $ef42fe9aca28652f$var$REASON,
            //
            sex: $ef42fe9aca28652f$var$SEX.male,
            ageGroup: null,
            ageGroupStatus: null,
            ageGroupOpen: false,
            userStatus: null,
            reason: "",
            pay: ""
        };
    },
    methods: {
        applySex (sex) {
            console.log("sex", sex);
            this.sex = sex;
            this.applyAgeGroup(null);
        },
        applyAgeGroup (group) {
            this.ageGroup = group;
            this.setStatus(null);
            this.closeAgeGroup();
        },
        openAgeGroup () {
            this.ageGroupOpen = true;
        },
        toggleAgeGroup () {
            this.ageGroupOpen = !this.ageGroupOpen;
        },
        closeAgeGroup () {
            this.ageGroupOpen = false;
        },
        setStatus (status) {
            this.userStatus = status;
        },
        hasReason (reasons) {
            if (this.reason) return reasons.includes(this.reason);
        },
        calcPayment (multiplier, max) {
            if (this.validPay) {
                var maxResult = max ? max : $ef42fe9aca28652f$var$MAX_PAY;
                var minResult = $ef42fe9aca28652f$var$MIN_PAY;
                var sum = this.pay * multiplier;
                var result = Math.floor(sum * 100) / 100;
                if (result > maxResult) result = maxResult;
                else if (result < minResult) result = minResult;
                return result.toLocaleString() + " руб.";
            }
        }
    },
    computed: {
        validPay () {
            return this.pay && Number.isInteger(+this.pay);
        },
        age () {
            if (!this.ageGroup) return;
            var year = new Date().getFullYear();
            return year - this.ageGroup.value;
        },
        status () {
            if (!this.ageGroup) return;
            if (this.userStatus !== null) return this.userStatus;
            switch(true){
                case this.age < this.ageGroup.preretirement:
                    return $ef42fe9aca28652f$var$STATUS.default;
                case this.age >= this.ageGroup.preretirement && this.age < this.ageGroup.retirement:
                    return $ef42fe9aca28652f$var$STATUS.preretirement;
                case this.age >= this.ageGroup.retirement:
                    return $ef42fe9aca28652f$var$STATUS.retirement;
            }
        }
    }
});


Vue.component("v-main", {
    props: [
        "site"
    ],
    mounted: function() {
        var slider = $(this.$el).find(".banners");
        var jobSlider = $(this.$el).find(".main__job-slider");
        var calendar = $(this.$el).find(".main__calendar #calendar");
        var scrollContainer = $(this.$el).find(".main__scroll-container .container-bounded ");
        var scrollEventsContainer = $(this.$el).find(".events__content-wrap");
        var scrollStoriesContainer = $(this.$el).find(".stories__content-wrap");
        var qr = $(this.$el).find(".main__qr");
        var bg;
        var fill;
        var scrollContainerHeight = 0;
        switch(this.$store.color){
            case "black":
                bg = "black";
                fill = "white";
                break;
            case "blue":
                bg = "#9dd1ff";
                fill = "black";
                break;
            default:
                bg = "white";
                fill = "black";
        }
        qr.qrcode({
            text: "http://" + this.site + "/getapp",
            size: 120,
            fill: fill,
            background: bg
        });
        scrollEventsContainer.slimScroll({
            height: "285px",
            size: "4px",
            color: "#C4C4C4"
        });
        scrollStoriesContainer.slimScroll({
            height: "550px",
            size: "4px",
            color: "#C4C4C4"
        });
        slider.on("init", function(event, slick) {
            scrollContainerHeight = $(".banners__carousel-item")[0].offsetHeight;
            scrollContainer.slimScroll({
                height: scrollContainerHeight ? 265 + scrollContainerHeight + "px" : "380px",
                size: "4px",
                color: "#C4C4C4"
            });
        });
        slider.slick({
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            dots: true,
            infinite: true,
            fade: true,
            cssEase: "linear",
            adaptiveHeight: true
        });
        jobSlider.slick({
            autoplay: true,
            autoplaySpeed: 3000,
            arrows: false,
            dots: false,
            infinite: true,
            fade: true,
            cssEase: "linear"
        });
        calendar.datetimepicker({
            inline: true,
            viewMode: "days",
            format: "DD/MM/YYYY",
            locale: "ru"
        }).on("dp.update", this.highlightDateHome);
        $(this.$el).find(".main__calendar .prev").html('<svg width="10" height="17"><use xlink:href="#svg-arrow-prev-cal-icon" /></svg>');
        $(this.$el).find(".main__calendar .next").html('<svg width="10" height="17"><use xlink:href="#svg-arrow-next-cal-icon" /></svg>');
        this.highlightDateHome();
        $(this.$el).find(".datepicker .day").click(function() {
            return false;
        });
        $(this.$el).find(".datepicker .picker-switch").click(function() {
            return false;
        });
        $(this.$el).find(".datepicker .day.highlight").click(function() {
            var url_arr = $(this).attr("data-day").split(".");
            document.location.href = "/events/" + url_arr[2] + "/" + url_arr[1] + "/" + url_arr[0];
            return false;
        });
        this.setBanner();
    },
    methods: {
        setBanner () {
            var banner = $("#js-show-iframe-wrapper");
            var bannerContainer = $(this.$el).find(".main__banner");
            if (banner.length && bannerContainer.length) {
                bannerContainer.append(banner);
                banner.show();
            }
        },
        highlightDateHome () {
            var self = this;
            var daysString = $(this.$el).find(".main__calendar #calendar").data("day");
            var days = [];
            if (daysString) {
                days = daysString.split(",");
                $.each(days, function(index, item) {
                    $(self.$el).find('#calendar td[data-day="' + item + '"]').addClass("highlight");
                });
            }
        }
    }
});


Vue.component("v-events", {
    props: [
        "month",
        "year"
    ],
    data: function() {
        return {
            months: [
                {
                    name: "Январь",
                    num: "01"
                },
                {
                    name: "Февраль",
                    num: "02"
                },
                {
                    name: "Март",
                    num: "03"
                },
                {
                    name: "Апрель",
                    num: "04"
                },
                {
                    name: "Май",
                    num: "05"
                },
                {
                    name: "Июнь",
                    num: "06"
                },
                {
                    name: "Июль",
                    num: "07"
                },
                {
                    name: "Август",
                    num: "08"
                },
                {
                    name: "Сентябрь",
                    num: "09"
                },
                {
                    name: "Октябрь",
                    num: "10"
                },
                {
                    name: "Ноябрь",
                    num: "11"
                },
                {
                    name: "Декабрь",
                    num: "12"
                }
            ],
            years: [],
            monthOpened: false,
            yearOpened: false
        };
    },
    mounted: function() {
        var self = this;
        this.years = this.getYears();
        $(this.$el).find(".events__calendar #calendar").datetimepicker({
            inline: true,
            viewMode: "days",
            format: "DD/MM/YYYY",
            locale: "ru",
            defaultDate: new Date(self.year, self.month - 1, 1)
        }).on("dp.update", self.highlightDate);
        $(this.$el).find(".events__calendar .prev").html('<svg width="11" height="18"><use xlink:href="#svg-arrow-prev-cal1-icon" /></svg>');
        $(this.$el).find(".events__calendar .next").html('<svg width="11" height="18"><use xlink:href="#svg-arrow-next-cal1-icon" /></svg>');
        this.highlightDate();
        $(this.$el).find(".next").click(function() {
            if (self.month >= 12) document.location.href = "/events/" + (self.year + 1) + "/1";
            else document.location.href = "/events/" + self.year + "/" + (self.month + 1);
            return false;
        });
        $(this.$el).find(".prev").click(function() {
            if (self.month <= 1) document.location.href = "/events/" + (self.year - 1) + "/12";
            else document.location.href = "/events/" + self.year + "/" + (self.month - 1);
            return false;
        });
        $(this.$el).find(".datepicker .day").click(function() {
            return false;
        });
        $(this.$el).find(".datepicker .picker-switch").click(function() {
            return false;
        });
        $(this.$el).find(".datepicker .day.highlight").click(function() {
            var url_arr = $(this).attr("data-day").split(".");
            document.location.href = "/events/" + url_arr[2] + "/" + url_arr[1] + "/" + url_arr[0];
            return false;
        });
        $(this.$el).find(".events__select-scroll[data-scroll]").slimScroll({
            height: "300px",
            size: "3px",
            color: "#C4C4C4"
        });
    },
    methods: {
        onClickOutsideMonths: function() {
            this.monthOpened = false;
        },
        onClickOutsideYears: function() {
            this.yearOpened = false;
        },
        toggleMonth: function() {
            this.monthOpened = !this.monthOpened;
        },
        toggleYear: function() {
            this.yearOpened = !this.yearOpened;
        },
        highlightDate: function() {
            var self = this;
            var daysString = $(this.$el).find("#calendar").data("day");
            var current = $(this.$el).find("#calendar").data("cur");
            var days = [];
            if (daysString) {
                days = daysString.split(",");
                $.each(days, function(index, item) {
                    $(self.$el).find('#calendar td[data-day="' + item + '"]').addClass("highlight");
                });
            }
            if (current) $(self.$el).find('#calendar td[data-day="' + current + '"]').addClass("current");
        },
        getYears: function() {
            var years = [];
            var curYear = new Date().getFullYear();
            var times = 5;
            for(var i = 0; i < times; i++)years.push(curYear - i);
            return years;
        }
    }
});


Vue.component("v-hmenu", {
    data: function() {
        return {
            opened: false
        };
    },
    methods: {
        open: function() {
            this.opened = true;
        },
        close: function() {
            this.opened = false;
        }
    }
});


Vue.component("v-banner", {
    data: function() {
        return {
            opened: false
        };
    },
    methods: {
        open: function() {
            this.opened = true;
        },
        close: function() {
            this.opened = false;
            setCookie("info_banner", Date.now(), {
                expires: 10000
            });
        }
    },
    mounted: function() {
        const daysCount = 3;
        const ts = Vue.$cookies.get("info_banner");
        const diff = Date.now() - ts;
        if (!ts || diff / 86400000 > daysCount) this.open();
    }
});


Vue.component("v-getapp", {
    mounted: function() {
        var ios = "https://apps.apple.com/ru/app/%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%B0-%D1%80%D0%BE%D1%81%D1%81%D0%B8%D0%B8/id1550617710?l=en&platform=iphone";
        var android = "https://play.google.com/store/apps/details?id=ru.trudvsem.mobile";
        var os = this.getMobileOperatingSystem();
        console.log("os", os);
        if (os === "ios") window.location.href = ios;
        else window.location.href = android;
    },
    methods: {
        getMobileOperatingSystem: function() {
            var userAgent = navigator.userAgent || navigator.vendor || window.opera;
            if (/windows phone/i.test(userAgent)) return "Windows Phone";
            if (/android/i.test(userAgent)) return "Android";
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return "iOS";
            return "unknown";
        }
    }
});


Vue.component("v-invalid", {
    data: function() {
        return {
            fonts: [
                "sm",
                "normal",
                "lg"
            ],
            colors: [
                "white",
                "black",
                "blue"
            ]
        };
    },
    mounted: function() {
        this.$actions.setInitialInvalidSettings();
    }
});


Vue.component("v-form", {
    methods: {
        validate: function() {
            var $form = $(this.$el).find("form");
            var hasError = false;
            $form.find('input:not([name="czn"]), textarea').map((index, el)=>{
                if (!$(el).val()) {
                    hasError = true;
                    $(el).closest(".form__input").addClass("form__input--error");
                }
            });
            return !hasError;
        },
        removeErrorState: function() {
            var $form = $(this.$el).find("form");
            $form.find(".form__input--error").removeClass("form__input--error");
        },
        send: function(e) {
            e.preventDefault();
            var $form = $(this.$el).find("form");
            var $formId = $form.attr("id");
            var $data = {
                formId: $formId,
                params: $form.serialize(),
                act: $form.attr("act")
            };
            var self = this;
            $.ajax({
                url: "/ajax.php",
                data: $data,
                type: "post",
                beforeSend: function() {
                    if (!self.validate()) return false;
                    $(e.target).attr("disabled", true);
                },
                success: function success(data) {
                    if (data.state) self.$actions.setFormSuccess(true);
                    else alert(data.msgtxt);
                    $(e.target).attr("disabled", false);
                    $form.find("input, textarea").val("");
                },
                error: function error() {
                    $(e.target).attr("disabled", false);
                    return alert("При отправке произошла непредвиденная ошибка! Повторите, пожалуйста, попытку позже.");
                }
            });
        }
    }
});


Vue.directive("click-outside", {
    bind (el, binding, vnode) {
        el.clickOutsideEvent = (event)=>{
            if (!(el === event.target || el.contains(event.target))) vnode.context[binding.expression](event);
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
    },
    unbind (el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
    }
});


Vue.component("v-calc", {
    data: function() {
        return {
            periods: [],
            applyDate: "",
            dischargeDate: "",
            postError: {}
        };
    },
    mounted: function() {
        this.initDatepicker(true);
    },
    methods: {
        onAdd: function() {
            if (!this.validate()) return;
            if (this.periods.length) {
                const lastPeriod = this.periods[this.periods.length - 1];
                this.periods.push({
                    outOfJob: true,
                    result: this.getDifference(lastPeriod.dischargeDate, this.applyDate, true)
                });
            }
            this.periods.push({
                applyDate: this.applyDate,
                dischargeDate: this.dischargeDate,
                result: this.getDifference(this.applyDate, this.dischargeDate),
                duration: this.calcDuration(this.applyDate, this.dischargeDate)
            });
            this.clear();
            const self = this;
            window.setTimeout(function() {
                self.initDatepicker();
            }, 0);
        },
        onNew: function() {
            const self = this;
            if (confirm("Все введенные данные будут удалены!\nНачать новый расчет?")) {
                this.clear();
                this.periods = [];
                this.total = "";
                window.setTimeout(function() {
                    self.initDatepicker();
                }, 0);
            }
        },
        getDifference: function(md1, md2, outOfJob) {
            const diff = this.calcDuration(md1, md2, outOfJob);
            if (diff === null) return diff;
            return {
                days: diff.days(),
                months: diff.months(),
                years: diff.years()
            };
        },
        calcDuration: function(md1, md2, outOfJob) {
            const d1 = this.getMomentDate(md1);
            const d2 = this.getMomentDate(md2);
            const previouslyDuration = moment.duration(d2.diff(d1));
            const duration = outOfJob ? previouslyDuration.subtract(1, "days") : previouslyDuration.add(1, "days");
            if (duration.as("days") === 0) return null;
            return duration;
        },
        getMomentDate: function(date) {
            const splittedStr = date.split(".");
            const day = splittedStr[0];
            const month = +splittedStr[1] - 1;
            const year = splittedStr[2];
            return moment([
                year,
                month,
                day
            ]);
        },
        declOfNum (number, titles) {
            const num = Math.abs(number);
            const cases = [
                2,
                0,
                1,
                1,
                1,
                2
            ];
            return titles[num % 100 > 4 && num % 100 < 20 ? 2 : cases[num % 10 < 5 ? num % 10 : 5]];
        },
        validate: function() {
            const d1 = this.getMomentDate(this.applyDate);
            const d2 = this.getMomentDate(this.dischargeDate);
            if (!this.applyDate || !this.dischargeDate) {
                this.postError = {
                    applyDate: !this.applyDate,
                    dischargeDate: !this.dischargeDate,
                    text: !this.applyDate && !this.dischargeDate ? "выберите даты" : `выберите дату ${!this.applyDate ? "начала" : "завершения"}`
                };
                return false;
            }
            if (d2 < d1) {
                this.postError = {
                    applyDate: true,
                    dischargeDate: true,
                    text: "Увольнение должно быть позднее приема на работу"
                };
                return false;
            } else return true;
        },
        change: function(el) {
            this[el.id] = el.value;
            this.postError = {};
        },
        initDatepicker: function(mounted) {
            let self = this;
            let fields = $(this.$el).find(".hasDatepicker");
            fields.val("");
            if (!mounted) try {
                fields.datetimepicker("destroy");
            } catch (err) {
                console.log(err);
            }
            fields.datetimepicker({
                viewMode: "days",
                format: "DD.MM.YYYY",
                locale: "ru",
                useCurrent: false
            }).on("dp.change", function(e) {
                self.change(this);
            }).on("dp.show", function(e) {
                $(self.$el).find(".datepicker .prev").html('<svg width="11" height="18"><use xlink:href="#svg-arrow-prev-cal1-icon" /></svg>');
                $(self.$el).find(".datepicker .next").html('<svg width="11" height="18"><use xlink:href="#svg-arrow-next-cal1-icon" /></svg>');
            });
        },
        clear: function() {
            this.applyDate = "";
            this.dischargeDate = "";
            this.postError = {};
        }
    },
    computed: {
        total: function() {
            let sum = null;
            if (this.periodItem) sum = moment.duration(sum).add(this.periodItem);
            this.periods.map((period)=>{
                if (!period.duration) return false;
                sum = moment.duration(sum).add(period.duration);
            });
            if (!sum) return null;
            return {
                days: sum.days(),
                months: sum.months(),
                years: sum.years()
            };
        },
        periodItem: function() {
            let d1 = this.getMomentDate(this.applyDate);
            let d2 = this.getMomentDate(this.dischargeDate);
            if (d1.isValid() && d2.isValid()) return moment.duration(d2.diff(d1)).add(1, "days");
            return null;
        },
        periodSum: function() {
            if (this.periodItem) return {
                days: this.periodItem.days(),
                months: this.periodItem.months(),
                years: this.periodItem.years()
            };
            return null;
        },
        preError: function() {
            let d1 = this.getMomentDate(this.applyDate);
            let d2 = this.getMomentDate(this.dischargeDate);
            if (d1.isValid() && d2.isValid()) {
                if (d2 < d1) return {
                    applyDate: true,
                    dischargeDate: true,
                    text: "Увольнение должно быть позднее приема на работу"
                };
            }
            return null;
        },
        error: function() {
            return this.preError ? this.preError : this.postError;
        }
    }
});


Vue.component("v-questions", {
    data: function() {
        return {
            opened: false
        };
    },
    methods: {
        open: function() {
            $(this.$el).css({
                zIndex: 9999
            });
            this.opened = true;
        },
        close: function() {
            $(this.$el).css({
                zIndex: 999
            });
            this.opened = false;
        },
        toggle: function() {
            if (this.opened) this.close();
            else this.open();
        }
    }
});


new Vue({
    el: "#app",
    delimiters: [
        "${",
        "}"
    ],
    created: function() {
        window.addEventListener("resize", this.handleViewport);
    },
    destroyed: function() {
        window.removeEventListener("resize", this.handleViewport);
    },
    mounted: function() {
        this.handleViewport();
    },
    methods: {
        handleViewport: function() {
            var mobile = window.matchMedia("(max-width: 767px)").matches;
            this.$actions.setViewport(mobile ? "mobile" : "desktop");
        }
    }
});



})();
//# sourceMappingURL=index.js.map
